import { render, staticRenderFns } from "./TrainingPlanSelectBooks.vue?vue&type=template&id=4bbb15fe&scoped=true&"
import script from "./TrainingPlanSelectBooks.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanSelectBooks.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPlanSelectBooks.vue?vue&type=style&index=0&id=4bbb15fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb15fe",
  null
  
)

export default component.exports